import React, { useRef, useState } from "react";
import { PSFS_StatPortalProps, PSFSElement } from "./Psfs_Slice";
import { FoundationsButton } from "../../GenericComponents/button";
import DatePicker from "../../GenericComponents/DatePicker";
declare let window: any
const UnicornApp = window.unicornInstance as any
import moment from "moment-timezone";

const OneWeekSetUpCall: React.FC<PSFS_StatPortalProps> = ({ form, setForm, handleStepStatusAndSave, PSFSElements, stepManuallyChanged, handleStatusResetAndClose, handleSave }) => {

    const formRef = useRef(null as any);
    const [isCustomerSite] = useState<boolean>(UnicornApp.checkUserPrivileges("NTSPAdmin"))
        const [errors, setErrors] = useState<{ [s: string]: string }>({})

    // Check if this step is already completed (form has moved past this step)
    const currentStepNo = PSFSElements?.PSFSStep?.find(step => step.ETLMatchValue === "OneWeekSetUpCall")?.StepNo ?? 1;
    const isStepCompleted = !stepManuallyChanged && form.fk_Step !== undefined && form.fk_Step !== -1 && form.fk_Step > currentStepNo;

    // Generic change handler for all fields
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        const nextValue = name === "IOSVersion"
        ? value.replace(/\s+/g, "") // remove all spaces
        : value;
        setForm(prev => ({
            ...prev,
            [name]: nextValue
        }));
    };

    // Handler for date field validation errors from DatePicker
    const handleDateValidationError = (fieldName: string) => (error: string) => {
        setErrors((prev: { [s: string]: string }) => ({
            ...prev,
            [fieldName]: error,
        }))
    }

    return (
        <>
            <form
                className="psfs-form-container"
                ref={formRef}
            >
                <>
                    <div className="psfs-container mb-1">
                        <div className="first-child mb-4">
                            <label className="psfs-main-label">NTSR Setup Call</label>
                            <div className="form-group mt-2">
                                <span style={{ lineHeight: "2.2" }}>
                                    Call veteran 2 weeks prior to appointment <br />
                                    Setup documents are located in the NTSR S: Drive <a href={PSFSElements?.PSFSUrl?.find?.((u: any) => u.FriendlyName === "NTSRDocumentLocated")?.Url} target="_blank" rel="noopener noreferrer">(Click here to open)</a><br />
                                    DO NOT CALL UNTIL YOU HAVE CONFIRMED DELIVERY OF EQUIPMENT<br />
                                    Check ROES for tracking info <a href={PSFSElements?.PSFSUrl?.find?.((u: any) => u.FriendlyName === "ROESTracking")?.Url} target="_blank" rel="noopener noreferrer">(Click here to go to ROES)</a><br />
                                </span>
                            </div>
                            <div className="form-group mt-3 mb-3">
                                <label className="" htmlFor="ts_DeliveryDate">
                                    Delivery Date <br />{' '}
                                </label>
                                <span>
                                    <div
                                        style={{
                                            display: 'flex',
                                            gap: '0.5rem',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <DatePicker
                                            id="ts_DeliveryDate"
                                            name="ts_DeliveryDate"
                                            dateFormat="MM/dd/yyyy"
                                            tabIndex={1}
                                            showMasking={true}
                                            className="psfs-fields"
                                            inputClass="psfs-fields"
                                            timeformat="HH:mm"
                                            showTime={false}
                                            startingDate={
                                                form.ts_DeliveryDate
                                                    ? (() => {
                                                        const m = moment.tz(form.ts_DeliveryDate, "YYYY-MM-DD", "America/New_York");
                                                        return new Date(m.year(), m.month(), m.date());
                                                      })()
                                                    : null
                                            }
                                            setStartingDate={(dateString) => {
                                                // Convert to EST before saving
                                                const m = moment.tz(dateString, "MM/DD/YYYY", "America/New_York");
                                                setForm(prev => ({
                                                    ...prev,
                                                    ts_DeliveryDate: m.isValid() ? m.format("YYYY-MM-DD") : ""
                                                }));
                                            }}
                                            interval={5}
                                            placeholder="Select date"
                                            isClearable={true}
                                            calendarClosed={false}
                                        // className="ntsp-fields"
                                            onValidationError={handleDateValidationError('ts_DeliveryDate')}
                                        />
                                    </div>
                                     {errors.ts_DeliveryDate && (
                                        <div
                                            style={{
                                                color: 'red',
                                                position: 'absolute',
                                                lineHeight: '1',
                                                fontSize: "smaller",
                                                margin: '3px',
                                            }}
                                        >
                                            {errors.ts_DeliveryDate + ''}
                                        </div>
                                    )}
                                </span>
                            </div>
                            <div className="form-group mt-2">
                                <p style={{ lineHeight: "2.2" }}>
                                    <label className="mb-2">Check White Glove Outcome <a href={PSFSElements?.PSFSUrl?.find?.((u: any) => u.FriendlyName === "WhiteGloveDashboard")?.Url} target="_blank" rel="noopener noreferrer">(Click here to go to dashboard)</a></label><br />
                                    1. Have veteran power on tablet and remind them to charge prior to appointment<br />
                                    2. Verify veteran has password setup and is able to get to home page<br />
                                    3. Verify veteran can see appointment(s) in VVC App<br />
                                    4. Offer to assist veteran with peripherals setup via Bluetooth<br />
                                    5. Offer veteran to install Stroke Recovery app
                                </p>
                            </div>
                            <div className="form-group mt-3">
                                <label className="" htmlFor="IOSVersion">
                                    iOS version
                                </label>
                                <span>
                                    <input
                                        type="text"
                                        className="psfs-fields"
                                        id="IOSVersion"
                                        name="IOSVersion"
                                        value={String(form.IOSVersion) || ''}
                                        onChange={handleChange}
                                        tabIndex={2}
                                        maxLength={12}
                                    />
                                </span>
                            </div>
                            <div className="form-group mt-3">
                                <label className="" htmlFor="AnnieBpReminders">
                                    ANNIE BP reminders <a href={PSFSElements?.PSFSUrl?.find?.((u: any) => u.FriendlyName === "ANNIEBPReminders")?.Url} target="_blank" rel="noopener noreferrer">(Click here to Enroll)</a>
                                </label>
                                <span>
                                    <select
                                        className="psfs-fields"
                                        id="fk_AnnieBpReminders"
                                        name="fk_AnnieBpReminders"
                                        value={form.fk_AnnieBpReminders}
                                        onChange={handleChange}
                                        tabIndex={3}
                                    >
                                        <option value="-1">-Select-</option>
                                        {PSFSElements?.YesNo?.sort((a, b) => a._key - b._key).map((YesNo: PSFSElement) => (
                                            <option key={YesNo._key} value={YesNo._key}>
                                                {YesNo.FriendlyName}
                                            </option>
                                        ))}
                                    </select>
                                </span>
                            </div>
                            <div className="form-group mt-3">
                                <label className="" htmlFor="fk_TestCallCompleted">
                                    Was a test call Completed?
                                </label>
                                <span>
                                    <select
                                        className="psfs-fields"
                                        id="fk_TestCallCompleted"
                                        name="fk_TestCallCompleted"
                                        value={form.fk_TestCallCompleted}
                                        onChange={handleChange}
                                        tabIndex={4}
                                    >
                                        <option value="-1">-Select-</option>
                                        {PSFSElements?.TCC?.sort((a, b) => a._key - b._key).map((TCC: PSFSElement) => (
                                            <option key={TCC._key} value={TCC._key}>
                                                {TCC.FriendlyName}
                                            </option>
                                        ))}
                                    </select>
                                </span>
                            </div>
                            <div className="form-group mt-3">
                                <label className="" htmlFor="StrokeRecoveryAppInstalled">
                                    Was stroke recovery app installed?
                                </label>
                                <span>
                                    <select
                                        className="psfs-fields"
                                        id="fk_StrokeRecoveryAppInstalled"
                                        name="fk_StrokeRecoveryAppInstalled"
                                        value={form.fk_StrokeRecoveryAppInstalled}
                                        onChange={handleChange}
                                        tabIndex={5}
                                    >
                                        <option value="-1">-Select-</option>
                                        {PSFSElements?.YesNo?.sort((a, b) => a._key - b._key).map((YesNo: PSFSElement) => (
                                            <option key={YesNo._key} value={YesNo._key}>
                                                {YesNo.FriendlyName}
                                            </option>
                                        ))}
                                    </select>
                                </span>
                            </div>
                            <div className="form-group psfs-buttons mt-10">
                                {!isStepCompleted && (
                                    <span>
                                        {PSFSElements?.PSFSStatus
                                            .filter((status: any) => status.FriendlyName === "1 Week Call Complete")
                                            .map((status: any) => (
                                                <span key={status._key}>
                                                    <FoundationsButton
                                                        id={status._key}
                                                        tabIndex={6}
                                                        disabled={Object.values(errors).some(Boolean) || !isCustomerSite}
                                                        buttonClasses="psfs-green-button"
                                                        onClick={() => handleStepStatusAndSave("OneWeekSetUpCall", status._key, "1-2DayReminderCall")}
                                                    >
                                                        {status.FriendlyName}
                                                    </FoundationsButton>
                                                </span>
                                            ))}
                                    </span>
                                )}
                                <span>
                                    <FoundationsButton
                                        id="-1"
                                        buttonClasses="app-button"
                                        onClick={() => handleSave(false)}
                                        disabled={Object.values(errors).some(Boolean)}
                                    >
                                        Save
                                    </FoundationsButton>
                                </span>
                                {!isStepCompleted && (
                                    <>
                                        <span>
                                            {PSFSElements?.PSFSStatus
                                                .filter((status: any) => status.FriendlyName === "Veteran Declined Appt.")
                                                .map((status: any) => (
                                                    <span key={status._key}>
                                                        <FoundationsButton
                                                            id={status._key}
                                                            tabIndex={7}
                                                            buttonClasses="psfs-red-button"
                                                            disabled={Object.values(errors).some(Boolean) || !isCustomerSite}
                                                            onClick={() => handleStatusResetAndClose("OneWeekSetUpCall", status._key, "1-2DayReminderCall")}
                                                        >
                                                            {status.FriendlyName}
                                                        </FoundationsButton>
                                                    </span>
                                                ))}
                                        </span>

                                        <span>
                                            {PSFSElements?.PSFSStatus
                                                .filter((status: any) => status.FriendlyName === "Clinically Canceled")
                                                .map((status: any) => (
                                                    <span key={status._key}>
                                                        <FoundationsButton
                                                            id={status._key}
                                                            tabIndex={8}
                                                            disabled={Object.values(errors).some(Boolean) || !isCustomerSite}
                                                            buttonClasses="psfs-red-button"
                                                            onClick={() => handleStatusResetAndClose("OneWeekSetUpCall", status._key, "1-2DayReminderCall")}
                                                        >
                                                            {status.FriendlyName}
                                                        </FoundationsButton>
                                                    </span>
                                                ))}
                                        </span>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            </form>

        </>
    );
}
export default OneWeekSetUpCall;